import { render, staticRenderFns } from "./FormsMessageCard.vue?vue&type=template&id=7ca96afb&scoped=true"
import script from "./FormsMessageCard.vue?vue&type=script&lang=js"
export * from "./FormsMessageCard.vue?vue&type=script&lang=js"
import style0 from "./FormsMessageCard.vue?vue&type=style&index=0&id=7ca96afb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca96afb",
  null
  
)

export default component.exports